import { render, staticRenderFns } from "./DetailBottomBar.vue?vue&type=template&id=56f55fe8&scoped=true&"
import script from "./DetailBottomBar.vue?vue&type=script&lang=js&"
export * from "./DetailBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailBottomBar.vue?vue&type=style&index=0&id=56f55fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f55fe8",
  null
  
)

export default component.exports